// Translations for the portfolio

export const translations = {
  en: {
    nav: {
      portfolio: "Portfolio",
      about: "About Me",
      linkedin: "LinkedIn",
      downloadCV: "Download CV",
      contact: "Contact"
    },
    hero: {
      experience: "Years Experience",
      viewPortfolio: "View Portfolio",
      connectLinkedIn: "Connect on LinkedIn",
      getInTouch: "Get in Touch"
    },
    skills: {
      title: "Core Expertise",
      digital: {
        title: "Digital",
        items: ["Social Media", "Paid Media", "CRM", "Influencer Marketing", "Performance & Analytics"]
      },
      retail: {
        title: "Retail & Experience",
        items: ["Retail Activation", "POS", "Visual Merchandising", "Experiential Marketing"]
      },
      strategy: {
        title: "Strategy & Growth",
        items: ["Go-to-Market", "Brand Positioning", "Omnichannel", "Commercial Performance", "Market Expansion", "Cross-Functional Leadership"]
      }
    },
    languages: {
      title: "Languages",
      items: [
        { name: "Portuguese & English", level: "Bilingual" },
        { name: "French", level: "Fluent" },
        { name: "Italian", level: "Fluent" },
        { name: "Spanish", level: "Good" }
      ]
    },
    about: {
      title: "Turning brand ambition into measurable growth",
      cta: {
        linkedin: "Connect on LinkedIn",
        contact: "Get in Touch"
      }
    },
    portfolio: {
      title: "Featured Portfolio",
      subtitle: "Strategic campaigns that drove measurable impact and brand growth",
      viewCaseStudy: "View Case Study"
    },
    contact: {
      title: "Let's Create Something Great",
      subtitle: "I'm currently exploring new opportunities where I can bring strategic thinking and proven results to drive brand growth.",
      getInTouch: "Get in Touch",
      email: "Email",
      linkedin: "LinkedIn",
      connectWithMe: "Connect with me",
      openTo: "Open to opportunities in:",
      opportunities: [
        "Brand Strategy & Marketing Leadership",
        "Digital Marketing",
        "FMCG/CPG Marketing Management",
        "Category Management & Innovation"
      ],
      form: {
        name: "Your Name",
        namePlaceholder: "John Doe",
        email: "Your Email",
        emailPlaceholder: "john@company.com",
        message: "Message",
        messagePlaceholder: "I'd love to discuss...",
        send: "Send Message",
        sending: "Sending..."
      }
    },
    footer: {
      tagline: "Strategic marketing leader driving impactful visibility and growth to fantastic brands",
      connect: "Connect",
      expertise: "Expertise",
      expertiseList: [
        "FMCG Marketing Strategy",
        "Category Management",
        "Brand Campaigns",
        "Through-the-Line Activation"
      ],
      rights: "All rights reserved.",
      madeWith: "Made with",
      and: "and awesome simplicity"
    },
    campaign: {
      backToAll: "Back to all campaigns",
      watchVideo: "Watch Launch Video",
      challenge: "The Challenge",
      solution: "The Solution",
      impact: "Impact",
      resultsTitle: "Results That Matter",
      visuals: "Campaign Visuals",
      viewAll: "View All Campaigns"
    }
  },
  fr: {
    nav: {
      portfolio: "Portfolio",
      about: "À Propos",
      linkedin: "LinkedIn",
      downloadCV: "Télécharger CV",
      contact: "Contact"
    },
    hero: {
      experience: "Ans d'Expérience",
      viewPortfolio: "Voir le Portfolio",
      connectLinkedIn: "Me Connecter sur LinkedIn",
      getInTouch: "Me Contacter"
    },
    skills: {
      title: "Expertises Clés",
      digital: {
        title: "Digital",
        items: ["Réseaux Sociaux", "Paid Media", "CRM", "Marketing d'Influence", "Performance & Analytics"]
      },
      retail: {
        title: "Retail & Expérience",
        items: ["Activation Retail", "PLV", "Merchandising Visuel", "Marketing Expérientiel"]
      },
      strategy: {
        title: "Stratégie & Croissance",
        items: ["Go-to-Market", "Positionnement de Marque", "Omnicanal", "Performance Commerciale", "Expansion de Marché", "Leadership Cross-Fonctionnel"]
      }
    },
    languages: {
      title: "Langues",
      items: [
        { name: "Portugais & Anglais", level: "Bilingue" },
        { name: "Français", level: "Courant" },
        { name: "Italien", level: "Courant" },
        { name: "Espagnol", level: "Bon niveau" }
      ]
    },
    about: {
      title: "Transformer l'ambition de marque en croissance mesurable",
      cta: {
        linkedin: "Me Connecter sur LinkedIn",
        contact: "Me Contacter"
      }
    },
    portfolio: {
      title: "Portfolio Sélectionné",
      subtitle: "Campagnes stratégiques ayant généré un impact mesurable et une croissance de marque",
      viewCaseStudy: "Voir l'Étude de Cas"
    },
    contact: {
      title: "Créons Quelque Chose de Grand Ensemble",
      subtitle: "Je suis actuellement à la recherche de nouvelles opportunités où je peux apporter une réflexion stratégique et des résultats prouvés pour stimuler la croissance de la marque.",
      getInTouch: "Me Contacter",
      email: "Email",
      linkedin: "LinkedIn",
      connectWithMe: "Me connecter",
      openTo: "Ouverte aux opportunités dans :",
      opportunities: [
        "Stratégie de Marque & Leadership Marketing",
        "Marketing Digital",
        "Direction Marketing FMCG/PGC",
        "Gestion de Catégorie & Innovation"
      ],
      form: {
        name: "Votre Nom",
        namePlaceholder: "Jean Dupont",
        email: "Votre Email",
        emailPlaceholder: "jean@entreprise.com",
        message: "Message",
        messagePlaceholder: "J'aimerais discuter de...",
        send: "Envoyer le Message",
        sending: "Envoi en cours..."
      }
    },
    footer: {
      tagline: "Leader marketing stratégique générant visibilité et croissance pour des marques fantastiques",
      connect: "Me Connecter",
      expertise: "Expertise",
      expertiseList: [
        "Stratégie Marketing FMCG",
        "Gestion de Catégorie",
        "Campagnes de Marque",
        "Activation 360°"
      ],
      rights: "Tous droits réservés.",
      madeWith: "Fait avec",
      and: "et une simplicité géniale"
    },
    campaign: {
      backToAll: "Retour aux campagnes",
      watchVideo: "Voir la Vidéo de Lancement",
      challenge: "Le Défi",
      solution: "La Solution",
      impact: "Impact",
      resultsTitle: "Résultats Qui Comptent",
      visuals: "Visuels de Campagne",
      viewAll: "Voir Toutes les Campagnes"
    }
  }
};

export const profileTranslations = {
  en: {
    name: "Joana Pestana Ramos",
    tagline: "Brand & Growth Marketing Manager",
    subtitle: "Bridging Strategy, Commercial & Digital Performance",
    statement: "Turning complex brand challenges into growth across international markets — translating strategy into high-impact digital and in-store activations.",
    location: "France"
  },
  fr: {
    name: "Joana Pestana Ramos",
    tagline: "Responsable Marketing & Croissance de Marque",
    subtitle: "Stratégie, performance commerciale et activation digitale",
    statement: "Transformer des enjeux de marque complexes en leviers de croissance sur des marchés internationaux — en déclinant la stratégie en activations digitales et en point de vente à fort impact.",
    location: "France"
  }
};

export const aboutTranslations = {
  en: {
    paragraphs: [
      "Over the past decade, I've worked with iconic brands, turning complex market challenges into campaigns that deliver real business impact. From launching a new brand with Ed Sheeran to activating high-impact partnerships with Disney and Coca-Cola, I combine creative thinking with a strong commercial and data-driven mindset.",
      "I focus on making ideas happen — translating vision into execution. Whether generating $6M in revenue from a new launch, building standout partnerships, or bringing fresh digital approaches to established brands, I bring both strategic clarity and hands-on delivery.",
      "If you're looking for a marketing leader who blends creativity, performance and execution, let's connect."
    ]
  },
  fr: {
    paragraphs: [
      "Au cours des dix dernières années, j'ai accompagné des marques emblématiques en transformant des enjeux complexes en campagnes générant un réel impact business. Du lancement d'une marque avec Ed Sheeran à l'activation de partenariats à fort impact avec Disney et Coca-Cola, j'allie créativité, sens business et approche data-driven.",
      "Je m'attache à concrétiser les idées — en traduisant la vision en exécution. Qu'il s'agisse de générer 6M$ de chiffre d'affaires lors d'un lancement, de construire des partenariats différenciants ou d'apporter des approches digitales innovantes à des marques établies, je combine vision stratégique et mise en œuvre opérationnelle.",
      "Si vous recherchez un profil marketing alliant créativité, performance et exécution, échangeons."
    ]
  }
};
